import { useAppDispatch, useAppSelector } from "../../hooks";
import CardWithImageBgAndBadgeTop from "./CardWithImageBgAndBadgeTop";
import { useEffect } from "react";
import { getCategoryTopics } from "../../slices/category";
import { Topic } from "../../types/category";
import { getCollections } from "../../slices/content";


export default function ExploreTopicsAndCollections() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getCategoryTopics({ pageNumber: 1, query: null }));
    dispatch(getCollections({ pageNumber: 1, query: null }));
  }, []);

  // Get app level state from redux store
  const {
    collections: { data: collectionData, loading: collectionLoading },
  } = useAppSelector((state) => state.content);
  const {
    topics: { data: topicsData, loading: topicsLoading },
  } = useAppSelector((state) => state.category);

  // Constant variables
  const exploreTopicsAndCollections: Array<{ id: string; type: "Topic" | "Collection"; name: string; image: string | null; slug: null | string }> = [];
  topicsData.forEach((topic: Topic) => exploreTopicsAndCollections.push({
    id: topic.id,
    type: "Topic",
    name: topic.name,
    image: topic.image,
    slug: topic.slug
  }));
  collectionData.forEach((collection: any) => exploreTopicsAndCollections.push({
    id: collection.id,
    type: "Collection",
    name: collection.name,
    image: collection.images.length > 0 ? collection.images[0] : null,
    slug: collection.slug
  }));
  exploreTopicsAndCollections.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="flex flex-row flex-nowrap w-100vw overflow-auto gap-x-4 pl-4 pb-4">
      {exploreTopicsAndCollections.map((content, index) => {
        return (
          <CardWithImageBgAndBadgeTop
            key={`explore-${index}`}
            objectId={content.id}
            objectType={content.type}
            showFavouriteButton={true}
            colour={content.type === "Topic" ? "yellow" : "mint-green"}
            image={content.image === null ? "/img/graphics/hero/landing-hero.png" : content.image}
            href={content.type === "Topic" ? `/topic/${content.slug}` : `/collection/${content.slug}`}
            badgeText={content.type}
            cardText={content.name}
          />
        )
      })}
    </div>
  );
}
